import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../../../services/auth-service';
import { NavigationHelper } from '../../../helpers/navigationHelper';

@Component({
  selector: 'app-qr-landing',
  imports: [],
  templateUrl: './qr-landing.html',
  styleUrl: 'qr-landing.scss',
})
export class QrLanding implements OnInit {

  private navigationHelper = inject(NavigationHelper);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);

  ngOnInit() {
    this.activatedRoute.queryParamMap.pipe(
      take(1),
      map((p) => p.get('id') as string))
      .subscribe(
        token => {
          const uuidMatcher = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
          if (uuidMatcher.test(token)) {
            this.authService.tryTokenLogin(token).then(({success, redirectTo}) => {
              if (success) {
                this.authService.currentFamilyId.set(token);
                this.navigationHelper.navigateTo([redirectTo]);
              } else {
                this.navigationHelper.navigateTo([`/`]);
              }
            }).catch(() => {
              this.navigationHelper.navigateTo([`/`]);
            });

          } else {
            this.navigationHelper.navigateTo([`/`]);
          }
        }
      );
  }
}
